const $$splitComponentImporter = () => import('/app/src/routes/dashboard/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface AdminStats {
  from: string;
  to: string;
  totalSessions: number;
  sessionsChange: number | null;
  completedSessions: number;
  completedChange: number | null;
  completionRate: number;
  totalRevenue: number;
  revenueChange: number | null;
  pendingPayouts: number;
  pendingPayoutSessionCount: number;
  newClientsInRange: number;
  actionItems: AdminActionItem[];
}